import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  const bullets = ['Licensed & Insured', 'Eco-Friendly Options', 'No Long-Term Contracts', 'Re-Service Guarantee', 'Locally Owned', '5-Star Rated'];
  return <section id="about" className="bg-brand-black py-16 md:py-24 px-4 md:px-6 overflow-hidden" data-id="element-14">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-15">
        {/* Left: Image Container */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="relative px-2 md:px-8" data-id="element-16">
          <div className="relative z-10 clip-about-img" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/5qMdfmhBGDJB7ZyyjGJjQ2/pestco_boss.webp" alt="Ultimate Pest Co Owners" className="w-full h-auto object-cover aspect-[4/3] grayscale-[20%] contrast-125" data-id="element-18" />
            {/* Green overlay blend */}
            <div className="absolute inset-0 bg-brand-green/10 mix-blend-overlay pointer-events-none" data-id="element-19" />
          </div>

          {/* Offset Border */}
          <div className="absolute inset-0 top-3 left-5 md:top-4 md:left-12 border-2 border-brand-green clip-about-img z-0 bg-brand-green/5" data-id="element-20" />

          {/* Badge */}
          <div className="absolute -bottom-6 right-0 md:right-4 z-20 bg-brand-green text-black font-condensed font-bold uppercase text-xl px-8 py-4 clip-parallelogram shadow-2xl" data-id="element-21">
            EST. 2020
          </div>
        </motion.div>

        {/* Right: Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="flex flex-col" data-id="element-22">
          <div className="flex items-center gap-4 mb-4" data-id="element-23">
            <div className="w-10 h-[2px] bg-brand-green" data-id="element-24" />
            <span className="font-condensed uppercase text-brand-green tracking-widest font-semibold" data-id="element-25">
              About Us
            </span>
          </div>

          <h2 className="text-4xl sm:text-5xl md:text-7xl text-white mb-6 md:mb-8" data-id="element-26">
            A <span className="text-brand-green" data-id="element-27">FAMILY</span> BUSINESS
          </h2>

          <p className="font-barlow text-base md:text-lg text-brand-gray leading-relaxed mb-8 md:mb-10" data-id="element-28">
            Ultimate Pest Co was founded in 2020 by a husband-and-wife team with
            a simple mission: provide honest, effective pest control that
            actually works. We are not a franchise. We are not a call center.
            When you call us, you get us — the people who actually show up and
            do the work. Every home we treat is treated like our own, because
            your trust means everything to us.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8" data-id="element-29">
            {bullets.map((bullet, index) => <div key={index} className="flex items-start" data-id="element-30">
                <div className="w-2 h-2 rounded-full bg-brand-green mt-2 mr-3 flex-shrink-0 shadow-[0_0_8px_rgba(93,204,58,0.6)]" data-id="element-31" />
                <span className="font-barlow text-white text-base font-medium" data-id="element-32">
                  {bullet}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}